<template>
    <div v-if="navMenus.length<=0" style="padding:20px;">
        <el-alert title="无子集菜单1" center type="info" :closable="false"></el-alert>
    </div>
    <template v-for="navMenu in navMenus" :key="navMenu">
        <el-menu-item v-if="!hasChildren(navMenu)" :index="navMenu.path">
            <a v-if="navMenu.meta&&navMenu.meta.type=='link'" :href="navMenu.path" target="_blank" @click.stop='()=>{}'></a>
            <ui-icon v-if="navMenu.meta && navMenu.meta.icon" :type="navMenu.meta.icon" class="el-menu-top-icon" />
            <template #title>
                <span>{{navMenu.meta.title}}</span>
                <span v-if="navMenu.meta.tag" class="menu-tag">{{navMenu.meta.tag}}</span>
            </template>
        </el-menu-item>
        <el-sub-menu v-else :index="navMenu.path">
            <template #title>
                <ui-icon v-if="navMenu.meta && navMenu.meta.icon" :type="navMenu.meta.icon" class="el-menu-top-icon" />
                <span>{{navMenu.meta.title}}</span>
                <span v-if="navMenu.meta.tag" class="menu-tag">{{navMenu.meta.tag}}</span>
            </template>
            <NavMenu :navMenus="navMenu.children"></NavMenu>
        </el-sub-menu>
    </template>
</template>

<script>
    import { getCurrentInstance, defineComponent, ref, watch, nextTick, computed } from 'vue'
    import { useNavlistStore, useLayoutStore } from '@/store'
    export default defineComponent({
        name: 'NavMenu',
        props: {
            navMenus: {
                type: [Object, Array],
                default: () => {}
            }
        },

        setup(props, context) {
            const hasChildren = (item) => {
                return item.children && !item.children.every(item => item.hidden)
            }

            return {
                hasChildren
            }
        }
    })
</script>
